import { z } from "zod";
export const CONTACT_ENQUIRY_TYPES = [
    "order_question",
    "order_amendment",
    "order_cancellation",
    "delivery_not_arrived",
    "delivery_damaged",
    "delivery_missing_items",
    "return_request",
    "refund_request",
    "refund_existing",
    "complaint",
    "product_info",
    "product_out_of_stock",
    "bulk_custom_order",
    "account_login_issue",
    "account_update",
    "account_closure",
    "billing_invoice_query",
    "billing_charge_dispute",
    "supplier_application",
    "supplier_existing_query",
    "partnership",
    "halal_certification",
    "media_press",
    "data_access_request",
    "data_deletion_request",
    "careers",
    "legal_compliance",
    "other",
];
export const CONTACT_ENQUIRY_OPTIONS = [
    {
        value: "order_question",
        label: "Order - I have a question about my order",
        responseTargetText: "1 business day",
    },
    {
        value: "order_amendment",
        label: "Order - I want to amend my order",
        responseTargetText: "1 business day",
    },
    {
        value: "order_cancellation",
        label: "Order - I want to cancel my order",
        responseTargetText: "1 business day",
    },
    {
        value: "delivery_not_arrived",
        label: "Delivery - My order hasn't arrived",
        responseTargetText: "1 business day",
    },
    {
        value: "delivery_damaged",
        label: "Delivery - My order arrived damaged",
        responseTargetText: "1 business day",
    },
    {
        value: "delivery_missing_items",
        label: "Delivery - Missing items in my order",
        responseTargetText: "1 business day",
    },
    {
        value: "return_request",
        label: "Returns - I want to return an item",
        responseTargetText: "2 business days",
    },
    {
        value: "refund_request",
        label: "Refund - I want to request a refund",
        responseTargetText: "2 business days",
    },
    {
        value: "refund_existing",
        label: "Refund - Query about an existing refund",
        responseTargetText: "2 business days",
    },
    {
        value: "complaint",
        label: "Complaint - I want to raise a complaint",
        responseTargetText: "Acknowledgement within 1 day; target response within 5 business days",
    },
    {
        value: "product_info",
        label: "Product - I need information about a product",
        responseTargetText: "1-2 business days",
    },
    {
        value: "product_out_of_stock",
        label: "Product - A product is out of stock",
        responseTargetText: "1-2 business days",
    },
    {
        value: "bulk_custom_order",
        label: "Product - Bulk or custom order enquiry",
        responseTargetText: "1-2 business days",
    },
    {
        value: "account_login_issue",
        label: "Account - I can't log in to my account",
        responseTargetText: "1-2 business days",
    },
    {
        value: "account_update",
        label: "Account - I want to update my account details",
        responseTargetText: "1-2 business days",
    },
    {
        value: "account_closure",
        label: "Account - I want to close my account",
        responseTargetText: "1-2 business days",
    },
    {
        value: "billing_invoice_query",
        label: "Billing - Query about an invoice",
        responseTargetText: "2 business days",
    },
    {
        value: "billing_charge_dispute",
        label: "Billing - I want to dispute a charge",
        responseTargetText: "2 business days",
    },
    {
        value: "supplier_application",
        label: "Supplier - I want to apply to supply on Wmart",
        responseTargetText: "5-7 business days",
    },
    {
        value: "supplier_existing_query",
        label: "Supplier - I'm an existing supplier with a query",
        responseTargetText: "5-7 business days",
    },
    {
        value: "partnership",
        label: "Partnership - Business or commercial partnership",
        responseTargetText: "3-5 business days",
    },
    {
        value: "halal_certification",
        label: "Halal Certification - I have a certification query",
        responseTargetText: "1-2 business days",
    },
    {
        value: "media_press",
        label: "Media & Press - I have a press enquiry",
        responseTargetText: "1-2 business days",
    },
    {
        value: "data_access_request",
        label: "Data & Privacy - Data access request",
        responseTargetText: "Within 1 calendar month",
    },
    {
        value: "data_deletion_request",
        label: "Data & Privacy - Data deletion request",
        responseTargetText: "Within 1 calendar month",
    },
    {
        value: "careers",
        label: "Careers - I'm interested in working at Wmart",
        responseTargetText: "General acknowledgement",
    },
    {
        value: "legal_compliance",
        label: "Legal - Legal or compliance matter",
        responseTargetText: "General acknowledgement",
    },
    {
        value: "other",
        label: "Other - My enquiry doesn't fit any of the above",
        responseTargetText: "1-2 business days",
    },
];
export const CONTACT_ORDER_RELATED_TYPES = [
    "order_question",
    "order_amendment",
    "order_cancellation",
    "delivery_not_arrived",
    "delivery_damaged",
    "delivery_missing_items",
    "return_request",
    "refund_request",
    "refund_existing",
    "billing_invoice_query",
    "billing_charge_dispute",
];
export const CONTACT_ORDER_NUMBER_REQUIRED_TYPES = [
    ...CONTACT_ORDER_RELATED_TYPES,
];
const CONTACT_ORDER_NUMBER_REQUIRED_TYPE_SET = new Set(CONTACT_ORDER_NUMBER_REQUIRED_TYPES);
const ContactEnquiryTypeSchema = z.enum(CONTACT_ENQUIRY_TYPES);
export const ContactSubmissionFieldsSchema = z
    .object({
    fullName: z.string().trim().min(1).max(200),
    businessName: z.string().trim().min(1).max(200),
    email: z.email(),
    phone: z.string().trim().max(50).optional().or(z.literal("")),
    enquiryType: ContactEnquiryTypeSchema,
    orderNumber: z.string().trim().max(100).optional().or(z.literal("")),
    message: z.string().trim().min(20).max(5000),
    privacyAccepted: z.literal(true),
})
    .superRefine((value, ctx) => {
    if (CONTACT_ORDER_NUMBER_REQUIRED_TYPE_SET.has(value.enquiryType) &&
        (!value.orderNumber || value.orderNumber.trim().length === 0)) {
        ctx.addIssue({
            code: "custom",
            path: ["orderNumber"],
            message: "Order number is required for this enquiry type.",
        });
    }
});
